<div class="audio-player" [class.compact]="compact" [class.loading]="isLoading" [class.no-audio]="!hasAudio">
  <!-- Waveform Display -->
  <div class="waveform-wrapper">
    <div #waveform class="waveform" [class.hidden]="!hasAudio"></div>

    @if (isLoading && hasAudio) {
      <div class="loading-overlay">
        <div class="loading-spinner"></div>
        <span class="loading-text">Loading audio...</span>
      </div>
    }

    @if (hasError && !isLoading) {
      <div class="no-audio-overlay error">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <span class="no-audio-text">Failed to load audio</span>
      </div>
    } @else if (!hasAudio && !isLoading) {
      <div class="no-audio-overlay">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 5L6 9H2v6h4l5 4V5z"/>
          <line x1="23" y1="9" x2="17" y2="15"/>
          <line x1="17" y1="9" x2="23" y2="15"/>
        </svg>
        <span class="no-audio-text">No audio selected</span>
      </div>
    }
  </div>

  <!-- Controls -->
  @if (showControls && hasAudio) {
    <div class="controls">
      <div class="controls-left">
        <!-- Skip Back -->
        <button
          class="control-btn skip-btn"
          (click)="skipBackward()"
          [disabled]="!isReady"
          title="Skip back 10s"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M11 19l-7-7 7-7M18 19l-7-7 7-7"/>
          </svg>
        </button>

        <!-- Play/Pause -->
        <button
          class="control-btn play-btn"
          (click)="togglePlay()"
          [disabled]="!isReady"
        >
          @if (isPlaying) {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="4" width="4" height="16" rx="1"/>
              <rect x="14" y="4" width="4" height="16" rx="1"/>
            </svg>
          } @else {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5.14v14.72a1 1 0 001.5.86l11-7.36a1 1 0 000-1.72l-11-7.36a1 1 0 00-1.5.86z"/>
            </svg>
          }
        </button>

        <!-- Skip Forward -->
        <button
          class="control-btn skip-btn"
          (click)="skipForward()"
          [disabled]="!isReady"
          title="Skip forward 10s"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M13 5l7 7-7 7M6 5l7 7-7 7"/>
          </svg>
        </button>
      </div>

      <div class="controls-center">
        @if (showTime) {
          <div class="time-display">
            <span class="current-time">{{ formatTime(currentTime) }}</span>
            @if (showDuration) {
              <span class="time-separator">/</span>
              <span class="total-time">{{ formatTime(duration) }}</span>
            }
          </div>
        }
      </div>

      <div class="controls-right">
        @if (showVolume) {
          <!-- Mute Toggle -->
          <button
            class="control-btn volume-btn"
            (click)="toggleMute()"
            title="{{ isMuted ? 'Unmute' : 'Mute' }}"
          >
            @if (isMuted || volume === 0) {
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 5L6 9H2v6h4l5 4V5z"/>
                <line x1="23" y1="9" x2="17" y2="15"/>
                <line x1="17" y1="9" x2="23" y2="15"/>
              </svg>
            } @else if (volume < 0.5) {
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 5L6 9H2v6h4l5 4V5z"/>
                <path d="M15.54 8.46a5 5 0 010 7.07"/>
              </svg>
            } @else {
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 5L6 9H2v6h4l5 4V5z"/>
                <path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/>
              </svg>
            }
          </button>

          <!-- Volume Slider -->
          <div class="volume-slider-container">
            <input
              type="range"
              class="volume-slider"
              min="0"
              max="1"
              step="0.01"
              [value]="isMuted ? 0 : volume"
              (input)="onVolumeChange($event)"
            />
          </div>
        }
      </div>
    </div>
  }
</div>
